import cx from "classnames";
import React, { useEffect, useState } from "react";

import { Container } from "@gamedev-web/gamedev-sdk-core";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { LoadingSpinner } from "../../../components/Spinner";
import { siteLocationPrefix } from "../../../constants";
import { getImage, ImageType } from "../../../helpers/imageHelper";
import { StreamingEuRequest } from "../models";
import {
  ErrorStepDefaultSubtitle,
  ErrorStepExistingUserSubtitle,
  StreamingEuStepTitle,
  ThankYouFootNote1Part1,
  ThankYouFootNote1Part2,
  ThankYouFootNote2Part1,
  ThankYouFootNote2Part2,
  ThankYouSubtitle,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

export type ThankYouProps = Readonly<{
  streamingData: StreamingEuRequest;
}>;

const saveCrmDataUrl = `${siteLocationPrefix}/streamingEu/send`;

export const ThankYou = ({ streamingData }: ThankYouProps) => {
  const [isDataStored, setIsDataStored] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(ErrorStepDefaultSubtitle);

  const resolveStatus = (status: number) => {
    switch (status) {
      case 200:
      case 201:
        setIsDataStored(true);
        break;
      case 423:
        setIsError(true);
        setErrorMessage(ErrorStepExistingUserSubtitle);
        break;
      case 500:
      default:
        setIsError(true);
        break;
    }
  };

  useEffect(() => {
    if (!isDataStored) {
      fetch(saveCrmDataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(streamingData),
      })
        .then(response => resolveStatus(response.status))
        .catch(error => resolveStatus(error.response.status));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isError) {
    return (
      <>
        <h1 className={styles.title}>{StreamingEuStepTitle.Error}</h1>
        <p>{errorMessage}</p>
        <div className={styles.horizontalCentering}>
          <StreamingEuCloseButton isPrimary={true} />
        </div>
      </>
    );
  }

  if (!isDataStored) {
    return (
      <Container className={cx(commonStyles.spinnerContainer, styles.spinnerBackground)}>
        <LoadingSpinner />
      </Container>
    );
  }

  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.ThankYou}</h1>
      <p>{ThankYouSubtitle}</p>
      <div className={styles.horizontalCentering}>
        <img
          src={getImage("streaming-eu-thankyou-image", ImageType.Png)}
          alt={StreamingEuStepTitle.ThankYou}
        />
      </div>
      <p>
        {ThankYouFootNote1Part1}
        <a
          href="https://learn.microsoft.com/gaming/azure/game-streaming/overview"
          target="_blank"
          rel="noopener noreferrer"
        >
          {ThankYouFootNote1Part2}
        </a>
      </p>
      <p>
        {ThankYouFootNote2Part1}
        <a
          href="https://www.xbox.com/legal/activision-blizzard-cloud-game-streaming-eu/faq"
          target="_blank"
          rel="noopener noreferrer"
        >
          {ThankYouFootNote2Part2}
        </a>
      </p>
      <div className={styles.horizontalCentering}>
        <StreamingEuCloseButton isPrimary={true} />
      </div>
    </>
  );
};
